import useBackend from '@/hooks/useBackend'
import useError from '@/hooks/useError'

import config from '@/config'

import { isRequired } from '@/utils/CustomErrors'

const { setup, doGet } = useBackend()
const { createErrorResponse } = useError()

setup('/ovpv3', config.microserviceBaseUrl, {
  responseSuccess: response => {
    return response.data
  },
  responseError: error => {
    throw createErrorResponse(error)
  },
})

export default function useCancellation() {
  function createPreInsurerVvg(cancellationDate, cancellationExisting = false) {
    return {
      cancellationExisting,
      preInsurerId: null,
      cancellationDate,
      preInsurerCustomerNumber: null,
      cancelAllProducts: null,
      products: null,
    }
  }

  function hasEmptyPreInsurer(personPreInsurerVvgs) {
    return personPreInsurerVvgs.length === 1 && personPreInsurerVvgs.every(p => p.cancellationExisting === false)
  }

  function isNotVVGOnlyOrOneProductSelected(form) {
    return Object.values(form).some(product => {
      if (product.preInsurer) return true
      if (product.preInsurerVvgs) {
        return product.preInsurerVvgs.some(vvg => vvg.cancellationExisting)
      }
      return false
    })
  }

  function _getCancellationQuestions({ basketId = isRequired('basketId'), jwToken = isRequired('jwToken') }) {
    return doGet(`/baskets/${basketId}/cancellationQuestions`, {
      basketId,
      jwToken,
    }).then(response => response.data.cancellationQuestions)
  }

  function loadCancellationQuestions(basketId, jwToken) {
    return _getCancellationQuestions({ basketId, jwToken })
  }

  function mapQuestionsToPerson(questions) {
    return questions.reduce((acc, q) => {
      acc[q.personId] = {
        kvg: q.kvg,
        vvg: q.vvg,
      }
      return acc
    }, {})
  }

  return {
    createPreInsurerVvg,
    hasEmptyPreInsurer,
    isNotVVGOnlyOrOneProductSelected,
    loadCancellationQuestions,
    mapQuestionsToPerson,
  }
}
